import React, { PropsWithChildren } from 'react'

const Section: React.FC <PropsWithChildren<any>> = ({ children }) => <div className = "boxSection"> {children} </div>

export default Section